//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import flick from '@/mixins/Flickity.js'
export default {
  mixins: [flick],
  props: ['professores'],
  data() {
    return {
      dialog: false,
      selectedProfessor: {},
      doFlick: true,
      options: {
        pageDots: false,
        cellAlign: 'center',
        autoPlay: 4000,
      },
    }
  },

  computed: {
    itemsCount: (v) => v.professores && v.professores.length,
  },
}
